(function () {
  angular
    .module("akitabox.building.detail")
    .controller("BuildingDetailController", BuildingDetailController);

  /** @ngInject */
  function BuildingDetailController(
    $window,
    $state,
    building,
    OrganizationService
  ) {
    var self = this;

    // Attributes
    self.building = building;
    self.organization = OrganizationService.getCurrent();
    self.quickLinks = getQuickLinks();

    // Functions
    self.addRequest = addRequest;
    self.addWorkOrder = addWorkOrder;
    self.selectAddress = selectAddress;
    self.selectQuickLink = selectQuickLink;

    // ------------------------
    //   Private Functions
    // ------------------------

    function addRequest() {
      $state.go("app.serviceRequests.create", {
        building: self.building._id,
      });
    }

    function addWorkOrder() {
      $state.go("app.workOrders.create", {
        building: self.building._id,
      });
    }

    function getQuickLinks() {
      var links = [];
      // Service requests and work orders
      if (self.organization.show_tasks) {
        links.push(
          {
            title: "Service Requests",
            icon: "announcement",
            state: {
              name: "app.building.serviceRequests",
            },
          },
          {
            title: "Work Orders",
            icon: "build",
            state: {
              name: "app.building.workOrders",
              params: {
                status: "open",
              },
            },
          }
        );
      }
      // Rooms
      links.push({
        title: "Rooms",
        icon: "dashboard",
        state: {
          name: "app.building.rooms",
        },
      });
      // Assets
      links.push({
        title: "Assets",
        icon: "room",
        state: {
          name: "app.building.assets",
        },
      });

      return links;
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    function selectAddress() {
      $window.open(
        "https://www.google.com/maps?q=" +
          self.building.lat +
          "," +
          self.building.lng,
        "_blank"
      );
    }

    function selectQuickLink(item) {
      var params = angular.isDefined(item.state.params)
        ? item.state.params
        : {};

      // Add account ID and building ID state params
      params.accountId = self.building.cre_account;
      params.buildingId = self.building._id;

      $state.go(item.state.name, params);
    }
  }
})();
